<div class="wrapper">
  @if ((isLoading || authError)) {
    <div class="control-page">
      @if (isLoading) {
        <div class="loading-badge">
          <my-spinner></my-spinner>
        </div>
      }
      @if ((!isLoading && authError)) {
        <div class="auth-error">
          {{'There was a problem authenticating your use of this sticker picker. Please make sure you\'re using a client that has Dimension enabled and correctly set up.' | translate}}
        </div>
      }
    </div>
  }
  @if ((!isLoading && !authError)) {
    <div class="sticker-picker">
      <div class="sticker-pack-list" (wheel)="scrollHorizontal($event)">
        <div class="sticker-pack-list-tool-bar">
          @if ((!(!isLoading && !authError && (!packs || packs.length === 0)))) {
            <div class="sticker-pack-list-search"
                 (click)="isSearchSticker = true"
                 (keydown.enter)="isSearchSticker = true"
            >
              <i class="fas fa-1x fa-search"></i>
            </div>
          }
          @if ((!isSearchSticker && isDesktop)) {
            <div class="sticker-pack-list-config" (click)="openIntegrationManager()" (keydown.enter)="openIntegrationManager()">
              <i class="fas fa-1x fa-plus-circle"></i>
            </div>
          }
          @if (!isSearchSticker) {
            <div class="sticker-pack-list-refresh" (click)="refresh()" (keydown.enter)="refresh()">
              <i class="fa fa-1x fa-sync"></i>
            </div>
          }
        </div>
        @if (isSearchSticker) {
          <div class="sticker-pack-list-search__box">
            <input class="input-search form-control"
              placeholder='Search sticker'
              [(ngModel)]="inputSearchSticker"
              (ngModelChange)="searchStickers($event)"/>
            <div class="sticker-pack-list-search__box-close-button" (click)="closeInputSearchStickers()">
              <i class="fas fa-1x fa-times-circle"></i>
            </div>
          </div>
        }
        @if (!isSearchSticker) {
          <div class="sticker-pack-list-items">
            <mat-tab-group [disableRipple]="true" [(selectedIndex)]="selectedIndex">
              @for (pack of (inputSearchSticker === '' ? packs : packsOfSearching); track trackById(i, pack); let i = $index) {
                <mat-tab>
                  <ng-template mat-tab-label>
                    <div class="sticker-pack-list-item">
                      @if (!pack.isAnimated) {
                        <img [src]="pack.animationOpts?.animationData || ''"
                          width="30" height="30" class="image" loading="lazy"
                          [alt]="pack.displayName" draggable="false"/>
                      }
                      @if (pack.isAnimated) {
                        <ng-lottie [options]="pack.animationOpts"
                        [styles]="{display: 'inline-block'}" width="30px" height="30px" ></ng-lottie>
                      }
                    </div>
                  </ng-template>
                </mat-tab>
              }
            </mat-tab-group>
          </div>
        }
      </div>
      @if ((!isLoading && !authError && (!packs || packs.length === 0))) {
        <div class="no-stickers">
          <img src="/assets/img/no_stickers.png" alt="No sticker found" />
          <span class="message">{{'You have no sticker packs.' | translate}}</span>
          @if (isDesktop) {
            <button class="btn btn-link btn-sm" (click)="openIntegrationManager()">
              {{'Add some stickers' | translate}}
            </button>
          }
        </div>
      }
      @if ((!isLoading && !authError && (isSearchSticker && inputSearchSticker!== '' && !packsOfSearching.length))) {
        <div class="no-stickers"
          >
          <img src="/assets/img/no_stickers.png" alt="No sticker found"/>
          <span class="message">{{'No stickers found.' | translate}}</span>
        </div>
      }
      <div class="sticker-pack md-content hidden-tab-header">
        <mat-tab-group [disableRipple]="true" [(selectedIndex)]="selectedIndex">
          @for (pack of (inputSearchSticker === '' ? packs : packsOfSearching); track trackById(i, pack); let i = $index) {
            <mat-tab>
              <ng-template matTabLabel></ng-template>
              <ng-template matTabContent>
                <div class="stickers"
                  (touchstart)="onTouchStart($event)"
                  (touchend)="onTouchEnd($event)">
                  <cdk-virtual-scroll-viewport
                    #stickerPack
                    itemSize="10"
                    orientation="vertical"
                    class="stickers-scroll"
                    >
                    <div class="sticker" *cdkVirtualFor="let sticker of pack.stickers;"
                      (click)="sendSticker(sticker, pack)" (keydown.enter)="sendSticker(sticker, pack)"
                      (pointerdown)="onStickerPressStart(sticker, $event)"
                      (contextmenu)="$event.preventDefault()">
                      @if (sticker.image.mimetype !== 'image/tgs') {
                        <img [src]="sticker.animationOpts?.animationData || ''"
                          width="48" height="48" class="image" loading="lazy"
                          [alt]="sticker.name.split(' ')[0]" draggable="false"/>
                      } @else {
                        <ng-lottie
                          [options]="sticker.animationOpts"
                          [styles]="{display: 'inline-block'}"
                          width="48px"
                          height="48px"
                        ></ng-lottie>
                      }
                    </div>
                  </cdk-virtual-scroll-viewport>
                </div>
              </ng-template>
            </mat-tab>
          }
        </mat-tab-group>
      </div>
    </div>
  }
  @if (previewSticker) {
    <div class="sticker-preview-backdrop">
      <div class="sticker-preview-content">
        @if (previewSticker.image.mimetype !== 'image/tgs') {
          <img [src]="previewImageData || previewSticker.animationOpts?.animationData || ''"
            class="sticker-preview-image" loading="lazy"
            [alt]="previewSticker.name.split(' ')[0]" draggable="false"/>
        } @else {
          <ng-lottie
            [options]="previewSticker.animationOpts"
            [styles]="{display: 'inline-block'}"
            width="200px"
            height="200px"
          ></ng-lottie>
        }
      </div>
    </div>
  }
</div>
